import removeAfterEffectsAsset from './v1_0_0/v1_0_0_migration';
import v1_0_1_patch from './v1_0_1/v1_0_1_migration';
import { Migration } from './types';

export default [removeAfterEffectsAsset, v1_0_1_patch] satisfies Migration<any, any>[];
